<template>
	<div class="logo-container">
		<img src="../assets/domain_buildlite.png" />
	</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../styles/components/logoContainer.scss';
</style>
